export const ProjectsImageFive = ({ pic }) => {
  return (
    <div className="projects-artwork-container">
      <img className="projects-artwork-5" src={pic} alt=""></img>
    </div>
  );
};
